import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { authServices } from "../../APIServices/UserData/authServices";
import { useNavigate } from "react-router-dom";

const OTP_LENGTH = 6;
const RESEND_TIME = 30;

const OtpVerification = ({
  setNextStep,
  setName,
  name,
  setEmail,
  email,
  roleType,
  setLoader,
  loader
}) => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(new Array(OTP_LENGTH).fill(""));
  const [timer, setTimer] = useState(RESEND_TIME);
  const inputsRef = useRef([]);

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  useEffect(() => {
    if (timer === 0) return;
    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < OTP_LENGTH - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const resendOtp = () => {
    setOtp(new Array(OTP_LENGTH).fill(""));
    setTimer(RESEND_TIME);
    inputsRef.current[0]?.focus();
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pastedData = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);

    if (!pastedData) return;

    const newOtp = [...otp];

    for (let i = 0; i < pastedData.length; i++) {
      newOtp[i] = pastedData[i];
    }

    setOtp(newOtp);

    const nextFocusIndex =
      pastedData.length < OTP_LENGTH ? pastedData.length : OTP_LENGTH - 1;

    inputsRef.current[nextFocusIndex]?.focus();
  };

  const isOtpComplete = otp.every((d) => d !== "");

  const userRegistration = async () => {
    setLoader(true)
    let userData = {}
    userData.name = name
    userData.email = email
    userData.roleType = roleType
    userData.otp = otp?.join("")
    let data = await authServices.userRegistration(userData)
    if (data?.status === "alreadyRegistred") {
      navigate("/signup");
    }
    if(data?.statusCode === 200){
      setNextStep(data?.status)
      setName(data?.name)
      setEmail(data?.email)
    }
    setLoader(false)
  }

  return (
    <>
      <p className="text-muted-sm text-center mb-4">
        Enter the 6-digit code sent to your email
      </p>

      <div className="d-flex justify-content-center gap-2 mb-3">
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputsRef.current[index] = el)}
            className="form-input text-center border"
            style={{ width: 45, fontSize: 18 }}
            maxLength={1}
            value={digit}
            onPaste={handlePaste}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
          />
        ))}
      </div>

      {timer > 0 ? (
        <p className="text-muted-sm text-center">
          Resend OTP in <strong>{timer}s</strong>
        </p>
      ) : (
        <p className="link-primary text-center CP" onClick={resendOtp}>
          Resend OTP
        </p>
      )}

      <div className="hstack gap-2">
        <Button
          className="w-100 btn-primary"
          disabled={!isOtpComplete || loader}
          onClick={userRegistration}
        >
          Verify & Continue
        </Button>
      </div>
    </>
  );
};

export default OtpVerification;
